import {
  Control,
  FieldError,
  FieldErrorsImpl,
  FieldValues,
  Merge,
  Path,
  useController,
} from "react-hook-form";
import React, { useState, useEffect, useRef } from "react";
import Lottie from "react-lottie";
import animationData from "../../../src/jsons/ddddot.json";

export interface IdTitleOwnershipModel {
  id: string;
  name: string;
}

type Props<Model, FieldModel extends FieldValues> = {
  APIgetValue?: string | number;
  mode?: "default" | "withRadio" | "multiSelect";
  size?: "small" | "regular" | "large" | "verysmall" | undefined;
  label: string;
  uidName?: any;
  options: Model[];
  getOptionLabel: (i: Model) => string | number;
  control?: Control<FieldModel, any>;
  name: Path<FieldModel> | any;
  errors?: FieldError | Merge<FieldError, FieldErrorsImpl<FieldModel>>;
  disabled?: boolean;
  success?: boolean;
  isRequired?: boolean;
  hasTopLeftLabel?: boolean;
  TopLeftLable?: any;
  MarginTop?: boolean;
  Reset?: any;
  showNonOption?: boolean;
  isLoading?: boolean;
  defaultSelectValue?: any;
  flex?: string | number;
  secondaryBackground?: boolean;
  customOptionGenerator?: (option: Model) => JSX.Element;
  onChange?(value: Model | null): string | string[] | void;
  setValue?(name: any, id: any): any;
  editable?: boolean;
};

function ControlledSelectElement<Model, FieldModel extends FieldValues>(
  props: Props<Model, FieldModel>
) {
  const {
    field: { onChange, value },
  } = useController({
    name: props.name,
    control: props.control,
  });
  const [selected, setSelected] = useState(false);
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelected(true);
    const selectedOption = props.options.find(
      (option) => props.getOptionLabel(option) === event.target.value
    );
    if (props.setValue) {
      props.setValue(
        props.name,
        JSON.parse(JSON.stringify(selectedOption))[props.name]
      );
    }

    onChange(
      String(JSON.parse(JSON.stringify(selectedOption))[props.name]) ?? null
    );
    props.onChange?.(selectedOption ?? null);
  };

  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef<HTMLDivElement>(null);
  const selectRef2 = useRef<HTMLDivElement>(null);
  const handleToggleOptions = () => {
    checkboxes = document.getElementById("checkBoxes");
    if (!isOpen) {
      setSelectIconStyle("rotate(180deg)");
    } else {
      setSelectIconStyle("rotate(0deg)");
    }
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        selectRef.current &&
        !selectRef.current.contains(event.target as Node)
      ) {
        mouseDownCH();
        setSelectIconStyle("rotate(0deg)");
      }

      if (
        selectRef2.current &&
        !selectRef2.current.contains(event.target as Node)
      ) {
        if (!isOpen) {
          setSelectIconStyle("rotate(0deg)");
        } else {
          setSelectIconStyle("rotate(180deg)");
        }

        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    checkboxes = document.getElementById("checkBoxes");
    if (checkboxes !== null) {
      checkboxes.style.display = "none";
    }

    if (props.mode === "withRadio") {
      onChange([] ?? null);
    }
  }, []);

  const [selectIconStyle, setSelectIconStyle] = useState("rotate(0deg)");

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  useEffect(() => {
    if (props.Reset === undefined) {
      setSelected(false);
    }
  }, [props.Reset]);

  const ref = useRef<any>(null);

  var checkboxes: HTMLElement | null = null;

  function mouseDownCH() {
    checkboxes = document.getElementById("checkBoxes");
    if (checkboxes !== null) {
      checkboxes.style.display = "none";
    }
  }

  const getHeight = {
    verysmall: "h-[50px]",
    small: "h-[92px]",
    regular: "h-[100px]",
    large: "h-[116px]",
  }[props?.size || "small"];

  const getInputClassName = () => {
    const baseClassName = `block w-full ${
      props?.size === "verysmall" ? "" : "pr-8 px-4 py-2"
    } border rounded-lg focus:outline-none focus:border-primary-700 appearance-none pr-5`;

    const sizeClassName = {
      verysmall: "h-[30px]",
      small: "h-[44px]",
      regular: "h-[52px]",
      large: "h-[60px]",
    }[props?.size || "small"];

    if (props.success) {
      return `${baseClassName} ${sizeClassName} text-green-600 border-green-500 bg-green-100 focus:text-green-700`;
    } else if (props.errors) {
      return `${baseClassName} ${sizeClassName} text-red-600 border-red-500 bg-red-100 focus:text-red-700`;
    } else if (props.disabled) {
      return `${baseClassName} ${sizeClassName} cursor-not-allowed text-gray-900 border-gray-300 bg-gray-50 opacity-50`;
    } else {
      return `${baseClassName} ${sizeClassName} focus:text-gray-900 bg-gray-50 text-gray-900 border-gray-300`;
    }
  };
  const [incomingVal, setIncomingVal] = useState<any>(undefined);
  useEffect(() => {
    if (incomingVal === undefined) {
      setIncomingVal(value);
    }
  }, [value]);

  useEffect(() => {
    setIncomingVal(value);
  }, [props.options]);
  const optionRef = useRef<any>(null);
  return (
    <>
      <div
        className={`flex flex-col ${
          props.flex ? `flex-${props.flex}` : "flex-1"
        } ${getHeight} relative inline-block ${props.MarginTop && ` mt-6`}`}
      >
        <label className="flex mb-2 justify-between text-gray-900 text-Body-OneLine/14/Regular">
          <div>
            {props.label}
            {props.isRequired && <span className="text-red-500">*</span>}
          </div>
          <div className="flex flex-col items-center justify-center">
            {props.hasTopLeftLabel && props.TopLeftLable}
          </div>
        </label>
        {props.isLoading ? (
          <div className={getInputClassName()}>
            <div className=" invisible">
              <h1>565656353534</h1>
            </div>
            <div
              className={`absolute max-sm:left-[36%] sm:left-[36%] md:left-[42%] lg:left-[36%] top-[27%]`}
            >
              <Lottie options={defaultOptions} height={50} width={50} />
            </div>
          </div>
        ) : (
          <div ref={selectRef2} onClick={handleToggleOptions}>
            <select
              value={
                props.APIgetValue === undefined || value !== incomingVal
                  ? props.getOptionLabel(value)
                  : props.APIgetValue
              }
              onChange={handleChange}
              disabled={props.editable ? false : props.disabled}
              className={getInputClassName()}
              ref={ref}
            >
              {props.showNonOption &&
                props.Reset === undefined &&
                props.APIgetValue === undefined &&
                !selected && (
                  <option
                    ref={optionRef}
                    id="optio"
                    value=""
                    className={`text-gray-500`}
                  >
                    {props.defaultSelectValue}
                  </option>
                )}

              {props.options.map((option, index) => (
                <option
                  ref={optionRef}
                  className={` text-gray-700 zoor flex pt-2 pb-2 pr-4 pl-4 justify-end rounded-lg items-center self-stretch p-2`}
                  key={index}
                  value={props.getOptionLabel(option)}
                >
                  {props.customOptionGenerator
                    ? props.customOptionGenerator(option)
                    : props.getOptionLabel(option)}
                </option>
              ))}
            </select>
          </div>
        )}
        {!props.isLoading && (
          <div
            onClick={() => {
              optionRef && optionRef?.current && optionRef?.current?.focus();
              ref && ref?.current && ref?.current?.focus();
            }}
            className={`bg-gray-50 z-[0] ${
              props?.size === "verysmall"
                ? "top-8 left-3 absolute"
                : "top-11 left-4 absolute"
            } w-4 h-4 bg-no-repeat bg-center dropdown-arrow `}
            style={{
              transform: props.disabled ? "rotate(0deg)" : selectIconStyle,
              backgroundImage: "url(/icons/chevron-down-outline.svg)",
            }}
          />
        )}

        {props.errors && (
          <p className="text-Body-OneLine/14/Regular text-red-600">
            {props.errors.message?.toString()}
          </p>
        )}
      </div>
    </>
  );
}

export default ControlledSelectElement;
